import React from "react";
import Lottie from "lottie-react";
import holdMoneyAnimationData from "../animations/holdMoneyAnimation3.json";
import transferAnimationData from "../animations/transferAnimation.json";

/** Three-column "Simple Steps" section (from modify-privacy-policy / NewHome). */
const SimpleStepsAfriPay = () => {
    return (
        <div className="w-full px-4 py-8 md:py-10 bg-[#F1F5F9]">
            <div className="max-w-7xl mx-auto">
                <h2 className="font-display-fran font-semibold text-[#030319] text-[22px] md:text-3xl text-center leading-[1.1] tracking-[-0.02em] mb-8 md:mb-10">
                    Simple Steps to Start Enjoying AfriPay
                </h2>

                <div className="relative">
                    <div className="absolute top-0 left-0 w-full h-32 hidden md:block pointer-events-none z-0">
                        <svg className="w-full h-full" viewBox="0 0 1200 100" preserveAspectRatio="none">
                            <path
                                d="M 80 85 Q 340 10, 600 85"
                                stroke="#D1D5DB"
                                strokeWidth="2"
                                fill="none"
                                strokeDasharray="4 4"
                            />
                            <path
                                d="M 600 85 Q 860 10, 1120 85"
                                stroke="#D1D5DB"
                                strokeWidth="2"
                                fill="none"
                                strokeDasharray="4 4"
                            />
                        </svg>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6 md:gap-8 relative z-10 lg:pt-8">
                        <div className="flex flex-col items-center">
                            <div className="w-full max-w-sm relative">
                                <div className=" absolute -top-8 left-8 w-10 h-10 rounded-full bg-white border border-gray-300 hidden md:flex items-center justify-center shadow-sm z-10">
                                    <span className="text-xl text-[#030319]">1</span>
                                </div>

                                <div className="bg-gradient-to-br from-gray-50 to-white rounded-[12px] py-6 px-4 shadow-lg border border-gray-200">
                                    <h3 className="text-[16px] font-medium text-gray-900 mb-2">
                                        Create an account
                                    </h3>
                                    <div className="text-[12px] space-y-1 mb-6">
                                        <p>Download AfriPay App or click on sign up on website</p>
                                        <p>Sign up with your email and phone number in a munite</p>
                                        <p>Verify your Identity with KYC verification</p>
                                    </div>

                                    <div className="flex justify-center mt-4">
                                        <img
                                            src="/images/step1.png"
                                            alt="Create account screen"
                                            className="w-full h-auto max-w-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="w-full max-w-sm relative">
                                <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white border border-gray-300 hidden md:flex items-center justify-center shadow-sm z-10">
                                    <span className="text-xl text-[#030319]">2</span>
                                </div>

                                <div className="bg-gradient-to-br from-gray-50 to-white rounded-[12px] py-6 px-4 shadow-lg border border-gray-200">
                                    <h3 className="text-[16px] font-medium text-gray-900 mb-2">
                                        Set up your wallet
                                    </h3>
                                    <div className="text-[12px] mb-8">
                                        <p>Complete our link to a particular wallet to have accest to the wallet</p>
                                        <br />
                                    </div>

                                    <div className="flex bg-[#F1F5F9] rounded-2xl justify-center mt-4 pt-6">
                                        <Lottie
                                            animationData={holdMoneyAnimationData}
                                            loop
                                            className="w-full h-[246px] max-w-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="w-full max-w-sm relative">
                                <div className="absolute -top-8 right-8 w-10 h-10 rounded-full bg-white border border-gray-300 hidden md:flex items-center justify-center shadow-sm z-10">
                                    <span className="text-xl text-[#030319]">3</span>
                                </div>

                                <div className="bg-gradient-to-br from-gray-50 to-white rounded-[12px] py-6 px-4 shadow-lg border border-gray-200">
                                    <h3 className="text-[16px] font-medium text-gray-900 mb-2">
                                        Receive and send
                                    </h3>
                                    <div className="text-[12px] mb-6">
                                        <p>Send and receive money all over the world USD, EUR, NGN and more</p>
                                        <br />
                                    </div>

                                    <div className="flex justify-center bg-[#F1F5F9] rounded-2xl py-2">
                                        <Lottie
                                            animationData={transferAnimationData}
                                            loop
                                            className="w-full h-[260px] max-w-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SimpleStepsAfriPay;
